import { Field } from '@formily/core'
import { connect, Fragment, h, mapProps, useField } from '@formily/vue'
import { defineComponent } from 'vue-demi'

import type {
  ElUpload as ElUploadProps,
  ElUploadInternalFileDetail,
} from '@didi-pebble/pebble-design-vue/types/upload'

import {
  Button as ElButton,
  Upload as ElUpload,
} from '@didi-pebble/pebble-design-vue'

export type UploadProps = ElUploadProps & {
  textContent?: String
  errorAdaptor?: (error?: ErrorEvent) => String
}

const UploadWrapper = defineComponent<UploadProps>({
  name: 'FUpload',
  props: {
    textContent: {
      type: String,
      default: '',
    },
    errorAdaptor: {
      type: Function,
      default(error?: ErrorEvent) {
        return error?.message || ''
      },
    },
  },
  setup(curProps: UploadProps, { slots, attrs, listeners, emit }) {
    return () => {
      const fieldRef = useField<Field>()
      const setFeedBack = (error?: ErrorEvent) => {
        const message = curProps.errorAdaptor(error)

        fieldRef.value.setFeedback({
          type: 'error',
          code: 'UploadError',
          messages: message ? [message] : [],
        })
      }

      const props = {
        ...attrs,
        onChange(
          file: ElUploadInternalFileDetail,
          fileList: ElUploadInternalFileDetail[]
        ) {
          ;(attrs.onChange as Function)?.(file, fileList)
          setFeedBack()
          emit('change', fileList)
        },

        onRemove(
          file: ElUploadInternalFileDetail,
          fileList: ElUploadInternalFileDetail[]
        ) {
          ;(attrs.onRemove as Function)?.(file, fileList)
          setFeedBack()
          emit('change', fileList)
        },

        onError(
          error: ErrorEvent,
          file: ElUploadInternalFileDetail,
          fileList: ElUploadInternalFileDetail[]
        ) {
          ;(attrs.onError as Function)?.(error, file, fileList)

          setTimeout(() => {
            setFeedBack(error)
          }, 0)
        },
      }
      const children = {
        ...slots,
      }
      if (!slots.default) {
        children.default = () => {
          const listType = attrs.listType
          const drag = attrs.drag

          if (drag) {
            return h(
              Fragment,
              {},
              {
                default: () => [
                  h('i', { staticClass: 'pb-icon-upload' }, {}),
                  h(
                    'div',
                    { staticClass: 'pb-upload__text' },
                    { default: () => [curProps.textContent] }
                  ),
                ],
              }
            )
          }

          if (listType === 'picture-card') {
            return h(
              'i',
              {
                staticClass: 'pb-icon-plus',
              },
              {}
            )
          }

          return h(
            ElButton,
            { props: { icon: 'pb-icon-upload2' } },
            { default: () => [curProps.textContent] }
          )
        }
      }
      return h(ElUpload, { attrs: props, on: listeners }, children)
    }
  },
})

export const Upload = connect(
  UploadWrapper,
  mapProps({ readOnly: 'readonly', value: 'fileList' })
)

export default Upload
